import React from "react";
import "./Help.css";
import { FaUserShield, FaShieldAlt, FaGift, FaExclamationCircle } from "react-icons/fa";

const HelpSecurityAwareness = () => {
  return (
    <section className="helpSection p-3">
      <div className="container-xl">
        <div className="helpHeader mb-4">
          <h2 className="fw-bold text-dark">Security & Awareness</h2>
          <p className="text-muted">
            Learn how to stay safe from scams, protect your personal information, and recognize suspicious activity.
          </p>
        </div>

        <div className="helpContent">
          {/* 1 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaUserShield />
            </div>
            <div className="helpText">
              <h5>What is social engineering?</h5>
              <p>
                Social engineering is a method scammers use to trick people into sharing private or financial details. 
                They often pretend to be a trusted company and provide a believable reason to get your personal information. 
                It may look genuine at first, so it’s important to stay alert.
              </p>
            </div>
          </div>

          {/* 2 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaShieldAlt />
            </div>
            <div className="helpText">
              <h5>How can I protect myself from online scams?</h5>
              <ul>
                <li>Watch out for messages with spelling mistakes or urgent requests.</li>
                <li>Type www.yovho.com yourself in a new browser tab instead of clicking random links.</li>
                <li>Hover over links before clicking to verify the address starts with “https://”.</li>
                <li>YOVHO never asks for credit card, debit card, or gift card details via email, phone, or text.</li>
              </ul>
            </div>
          </div>

          {/* 3 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaGift />
            </div>
            <div className="helpText">
              <h5>Someone asked me to pay by gift card or phone. What should I do?</h5>
              <p>
                YOVHO never asks for payments via gift cards or phone. Stop communication immediately if this happens and report it — it’s most likely a scam.
              </p>
            </div>
          </div>

          {/* 4 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaExclamationCircle />
            </div>
            <div className="helpText">
              <h5>I think I was tricked by a fake message. What can I do?</h5>
              <p>
                Contact our team immediately via <a href="https://yovho.com/contact" target="_blank" rel="noreferrer">yovho.com/contact</a> or your booking dashboard. 
                If payment was already made, report it to your bank or payment company and keep any proof or receipts. 
                Our support team may need them to investigate further.
              </p>
              <p>
                Always book through YOVHO.com to ensure verified properties and secure systems. Your safety, privacy, and trust are our top priorities.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HelpSecurityAwareness;
